import { useEffect, useState } from "react";
import QRCode from "qrcode";
import { pairingUrl } from "./pairing.js";

export default function PhoneLink({ inbox, show }) {
  const [image, setImage] = useState("");
  const [error, setError] = useState("");
  const url = pairingUrl(window.location.origin, inbox);
  useEffect(() => {
    let active = true;
    setImage("");
    setError("");
    QRCode.toDataURL(url, { width: 260, margin: 4, errorCorrectionLevel: "M" })
      .then(value => { if (active) setImage(value); })
      .catch(() => { if (active) setError("QR code could not load. Copy the private phone link below instead."); });
    return () => { active = false; };
  }, [url]);

  return <section className="phoneLink glass" aria-labelledby="phone-link-title">
    <div className="qrFrame">
      {image ? <img src={image} width="260" height="260" alt="Scan with your phone camera to open your private EMX Notes workspace" /> : <p role="status">{error || "Creating private QR code…"}</p>}
    </div>
    <div>
      <p className="eyebrow">NO DOWNLOAD NEEDED</p>
      <h2 id="phone-link-title">Scan. Write. Send.</h2>
      <p>Scan this QR with your phone camera. Keep this browser open on your PC and send notes in either direction below.</p>
      <p>On your phone, use <b>Add to Home Screen</b> to install the PWA. Keep this QR private: anyone with it can access this paired workspace.</p>
      <button className="quietButton" onClick={async () => {
        try { await navigator.clipboard.writeText(url); show("Private phone link copied.", "success"); }
        catch { show("Clipboard unavailable. Select the private link below and copy it.", "error"); }
      }}>Copy phone link</button>
      <details className="manualPair"><summary>Show private phone link</summary><input aria-label="Private phone link" value={url} readOnly onFocus={event => event.target.select()} /></details>
    </div>
  </section>;
}
